module.exports = __webpack_public_path__ + "static/media/ic_update_hover.51a7f1a2.svg";